"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notesApi = exports.deteleNote = exports.postNote = exports.getNotes = void 0;
const getNotes = (caller) => ({ accountId, query }) => caller(`/accounts/${accountId}/notes`).get(query);
exports.getNotes = getNotes;
const postNote = (caller) => (options) => caller(`/accounts/${options.accountId}/notes`).post(options.payload);
exports.postNote = postNote;
const deteleNote = (caller) => (options) => caller(`/accounts/${options.accountId}/notes/${options.noteId}`).delete();
exports.deteleNote = deteleNote;
const notesApi = (caller) => ({
    getNotes: (0, exports.getNotes)(caller),
    postNote: (0, exports.postNote)(caller),
    deleteNote: (0, exports.deteleNote)(caller),
});
exports.notesApi = notesApi;
//# sourceMappingURL=api.js.map